// src/components/data/countryCodes.js

export const countryCodes = [
  // +1 countries (USA, Canada, etc.)
  { value: "+1", label: "+1 (USA)", country: "United States" },
  { value: "+1", label: "+1 (CAN)", country: "Canada" }, // Note: Same code, different region
  
  // +7
  { value: "+7", label: "+7 (RUS)", country: "Russia" },
  { value: "+7", label: "+7 (KAZ)", country: "Kazakhstan" },
  
  // +20 - +99
  { value: "+20", label: "+20 (EGY)", country: "Egypt" },
  { value: "+27", label: "+27 (RSA)", country: "South Africa" },
  { value: "+30", label: "+30 (GRE)", country: "Greece" },
  { value: "+31", label: "+31 (NED)", country: "Netherlands" },
  { value: "+32", label: "+32 (BEL)", country: "Belgium" },
  { value: "+33", label: "+33 (FRA)", country: "France" },
  { value: "+34", label: "+34 (ESP)", country: "Spain" },
  { value: "+36", label: "+36 (HUN)", country: "Hungary" },
  { value: "+39", label: "+39 (ITA)", country: "Italy" },
  { value: "+40", label: "+40 (ROM)", country: "Romania" },
  { value: "+41", label: "+41 (SUI)", country: "Switzerland" },
  { value: "+43", label: "+43 (AUT)", country: "Austria" },
  { value: "+44", label: "+44 (UK)", country: "United Kingdom" },
  { value: "+45", label: "+45 (DEN)", country: "Denmark" },
  { value: "+46", label: "+46 (SWE)", country: "Sweden" },
  { value: "+47", label: "+47 (NOR)", country: "Norway" },
  { value: "+48", label: "+48 (POL)", country: "Poland" },
  { value: "+49", label: "+49 (GER)", country: "Germany" },
  { value: "+51", label: "+51 (PER)", country: "Peru" },
  { value: "+52", label: "+52 (MEX)", country: "Mexico" },
  { value: "+53", label: "+53 (CUB)", country: "Cuba" },
  { value: "+54", label: "+54 (ARG)", country: "Argentina" },
  { value: "+55", label: "+55 (BRA)", country: "Brazil" },
  { value: "+56", label: "+56 (CHI)", country: "Chile" },
  { value: "+57", label: "+57 (COL)", country: "Colombia" },
  { value: "+58", label: "+58 (VEN)", country: "Venezuela" },
  { value: "+60", label: "+60 (MAS)", country: "Malaysia" },
  { value: "+61", label: "+61 (AUS)", country: "Australia" },
  { value: "+62", label: "+62 (INA)", country: "Indonesia" },
  { value: "+63", label: "+63 (PHI)", country: "Philippines" },
  { value: "+64", label: "+64 (NZL)", country: "New Zealand" },
  { value: "+65", label: "+65 (SIN)", country: "Singapore" },
  { value: "+66", label: "+66 (THA)", country: "Thailand" },
  { value: "+81", label: "+81 (JPN)", country: "Japan" },
  { value: "+82", label: "+82 (KOR)", country: "South Korea" },
  { value: "+84", label: "+84 (VIE)", country: "Vietnam" },
  { value: "+86", label: "+86 (CHN)", country: "China" },
  { value: "+90", label: "+90 (TUR)", country: "Turkey" },
  { value: "+91", label: "+91 (IND)", country: "India" },
  { value: "+92", label: "+92 (PAK)", country: "Pakistan" },
  { value: "+93", label: "+93 (AFG)", country: "Afghanistan" },
  { value: "+94", label: "+94 (SRI)", country: "Sri Lanka" },
  { value: "+95", label: "+95 (MYA)", country: "Myanmar" },
  { value: "+98", label: "+98 (IRN)", country: "Iran" },
  
  // +211 - +299
  { value: "+211", label: "+211 (SSD)", country: "South Sudan" },
  { value: "+212", label: "+212 (MOR)", country: "Morocco" },
  { value: "+213", label: "+213 (ALG)", country: "Algeria" },
  { value: "+216", label: "+216 (TUN)", country: "Tunisia" },
  { value: "+218", label: "+218 (LBY)", country: "Libya" },
  { value: "+220", label: "+220 (GAM)", country: "Gambia" },
  { value: "+221", label: "+221 (SEN)", country: "Senegal" },
  { value: "+222", label: "+222 (MAU)", country: "Mauritania" },
  { value: "+223", label: "+223 (MLI)", country: "Mali" },
  { value: "+224", label: "+224 (GUI)", country: "Guinea" },
  { value: "+225", label: "+225 (CIV)", country: "Côte d'Ivoire" },
  { value: "+226", label: "+226 (BUR)", country: "Burkina Faso" },
  { value: "+227", label: "+227 (NIG)", country: "Niger" },
  { value: "+228", label: "+228 (TOG)", country: "Togo" },
  { value: "+229", label: "+229 (BEN)", country: "Benin" },
  { value: "+230", label: "+230 (MRI)", country: "Mauritius" },
  { value: "+231", label: "+231 (LBR)", country: "Liberia" },
  { value: "+232", label: "+232 (SLE)", country: "Sierra Leone" },
  { value: "+233", label: "+233 (GHA)", country: "Ghana" },
  { value: "+234", label: "+234 (NGA)", country: "Nigeria" },
  { value: "+235", label: "+235 (CHA)", country: "Chad" },
  { value: "+236", label: "+236 (CAF)", country: "Central African Republic" },
  { value: "+237", label: "+237 (CMR)", country: "Cameroon" },
  { value: "+238", label: "+238 (CPV)", country: "Cape Verde" },
  { value: "+239", label: "+239 (STP)", country: "Sao Tome and Principe" },
  { value: "+240", label: "+240 (EQG)", country: "Equatorial Guinea" },
  { value: "+241", label: "+241 (GAB)", country: "Gabon" },
  { value: "+242", label: "+242 (CGO)", country: "Congo" },
  { value: "+243", label: "+243 (DRC)", country: "Congo, Democratic Republic" },
  { value: "+244", label: "+244 (ANG)", country: "Angola" },
  { value: "+245", label: "+245 (GNB)", country: "Guinea-Bissau" },
  { value: "+248", label: "+248 (SEY)", country: "Seychelles" },
  { value: "+249", label: "+249 (SUD)", country: "Sudan" },
  { value: "+250", label: "+250 (RWA)", country: "Rwanda" },
  { value: "+251", label: "+251 (ETH)", country: "Ethiopia" },
  { value: "+252", label: "+252 (SOM)", country: "Somalia" },
  { value: "+253", label: "+253 (DJI)", country: "Djibouti" },
  { value: "+254", label: "+254 (KEN)", country: "Kenya" },
  { value: "+255", label: "+255 (TAN)", country: "Tanzania" },
  { value: "+256", label: "+256 (UGA)", country: "Uganda" },
  { value: "+257", label: "+257 (BDI)", country: "Burundi" },
  { value: "+258", label: "+258 (MOZ)", country: "Mozambique" },
  { value: "+260", label: "+260 (ZAM)", country: "Zambia" },
  { value: "+261", label: "+261 (MAD)", country: "Madagascar" },
  { value: "+263", label: "+263 (ZIM)", country: "Zimbabwe" },
  { value: "+264", label: "+264 (NAM)", country: "Namibia" },
  { value: "+265", label: "+265 (MAW)", country: "Malawi" },
  { value: "+266", label: "+266 (LES)", country: "Lesotho" },
  { value: "+267", label: "+267 (BOT)", country: "Botswana" },
  { value: "+268", label: "+268 (SWZ)", country: "Eswatini" },
  { value: "+269", label: "+269 (COM)", country: "Comoros" },
  
  // +290 - +299
  { value: "+290", label: "+290 (SHN)", country: "Saint Helena" },
  { value: "+291", label: "+291 (ERI)", country: "Eritrea" },
  { value: "+297", label: "+297 (ARU)", country: "Aruba" },
  { value: "+298", label: "+298 (FRO)", country: "Faroe Islands" },
  { value: "+299", label: "+299 (GRL)", country: "Greenland" },
  
  // +350 - +389
  { value: "+350", label: "+350 (GIB)", country: "Gibraltar" },
  { value: "+351", label: "+351 (POR)", country: "Portugal" },
  { value: "+352", label: "+352 (LUX)", country: "Luxembourg" },
  { value: "+353", label: "+353 (IRE)", country: "Ireland" },
  { value: "+354", label: "+354 (ICE)", country: "Iceland" },
  { value: "+355", label: "+355 (ALB)", country: "Albania" },
  { value: "+356", label: "+356 (MLT)", country: "Malta" },
  { value: "+357", label: "+357 (CYP)", country: "Cyprus" },
  { value: "+358", label: "+358 (FIN)", country: "Finland" },
  { value: "+359", label: "+359 (BUL)", country: "Bulgaria" },
  { value: "+370", label: "+370 (LIT)", country: "Lithuania" },
  { value: "+371", label: "+371 (LAT)", country: "Latvia" },
  { value: "+372", label: "+372 (EST)", country: "Estonia" },
  { value: "+373", label: "+373 (MDA)", country: "Moldova" },
  { value: "+374", label: "+374 (ARM)", country: "Armenia" },
  { value: "+375", label: "+375 (BLR)", country: "Belarus" },
  { value: "+376", label: "+376 (AND)", country: "Andorra" },
  { value: "+377", label: "+377 (MON)", country: "Monaco" },
  { value: "+378", label: "+378 (SMR)", country: "San Marino" },
  { value: "+379", label: "+379 (VAT)", country: "Vatican City" },
  { value: "+380", label: "+380 (UKR)", country: "Ukraine" },
  { value: "+381", label: "+381 (SRB)", country: "Serbia" },
  { value: "+382", label: "+382 (MNE)", country: "Montenegro" },
  { value: "+385", label: "+385 (CRO)", country: "Croatia" },
  { value: "+386", label: "+386 (SVN)", country: "Slovenia" },
  { value: "+387", label: "+387 (BIH)", country: "Bosnia and Herzegovina" },
  { value: "+389", label: "+389 (MKD)", country: "North Macedonia" },
  
  // +420 - +599
  { value: "+420", label: "+420 (CZE)", country: "Czech Republic" },
  { value: "+421", label: "+421 (SVK)", country: "Slovakia" },
  { value: "+423", label: "+423 (LIE)", country: "Liechtenstein" },
  { value: "+500", label: "+500 (FLK)", country: "Falkland Islands" },
  { value: "+501", label: "+501 (BLZ)", country: "Belize" },
  { value: "+502", label: "+502 (GUA)", country: "Guatemala" },
  { value: "+503", label: "+503 (SAL)", country: "El Salvador" },
  { value: "+504", label: "+504 (HON)", country: "Honduras" },
  { value: "+505", label: "+505 (NIC)", country: "Nicaragua" },
  { value: "+506", label: "+506 (CRC)", country: "Costa Rica" },
  { value: "+507", label: "+507 (PAN)", country: "Panama" },
  { value: "+508", label: "+508 (SPM)", country: "Saint Pierre and Miquelon" },
  { value: "+509", label: "+509 (HAI)", country: "Haiti" },
  { value: "+590", label: "+590 (GLP)", country: "Guadeloupe" },
  { value: "+591", label: "+591 (BOL)", country: "Bolivia" },
  { value: "+592", label: "+592 (GUY)", country: "Guyana" },
  { value: "+593", label: "+593 (ECU)", country: "Ecuador" },
  { value: "+594", label: "+594 (GUF)", country: "French Guiana" },
  { value: "+595", label: "+595 (PAR)", country: "Paraguay" },
  { value: "+596", label: "+596 (MTQ)", country: "Martinique" },
  { value: "+597", label: "+597 (SUR)", country: "Suriname" },
  { value: "+598", label: "+598 (URU)", country: "Uruguay" },
  { value: "+599", label: "+599 (ANT)", country: "Netherlands Antilles" },
  
  // +670 - +699
  { value: "+670", label: "+670 (TLS)", country: "Timor-Leste" },
  { value: "+672", label: "+672 (NFK)", country: "Norfolk Island" },
  { value: "+673", label: "+673 (BRU)", country: "Brunei" },
  { value: "+674", label: "+674 (NRU)", country: "Nauru" },
  { value: "+675", label: "+675 (PNG)", country: "Papua New Guinea" },
  { value: "+676", label: "+676 (TON)", country: "Tonga" },
  { value: "+677", label: "+677 (SOL)", country: "Solomon Islands" },
  { value: "+678", label: "+678 (VAN)", country: "Vanuatu" },
  { value: "+679", label: "+679 (FIJ)", country: "Fiji" },
  { value: "+680", label: "+680 (PLW)", country: "Palau" },
  { value: "+681", label: "+681 (WLF)", country: "Wallis and Futuna" },
  { value: "+682", label: "+682 (COK)", country: "Cook Islands" },
  { value: "+683", label: "+683 (NIU)", country: "Niue" },
  { value: "+685", label: "+685 (SAM)", country: "Samoa" },
  { value: "+686", label: "+686 (KIR)", country: "Kiribati" },
  { value: "+687", label: "+687 (NCL)", country: "New Caledonia" },
  { value: "+688", label: "+688 (TUV)", country: "Tuvalu" },
  { value: "+689", label: "+689 (PYF)", country: "French Polynesia" },
  { value: "+690", label: "+690 (TKL)", country: "Tokelau" },
  { value: "+691", label: "+691 (FSM)", country: "Micronesia" },
  { value: "+692", label: "+692 (MHL)", country: "Marshall Islands" },
  
  // +850 - +899
  { value: "+850", label: "+850 (PRK)", country: "North Korea" },
  { value: "+852", label: "+852 (HKG)", country: "Hong Kong" },
  { value: "+853", label: "+853 (MAC)", country: "Macau" },
  { value: "+855", label: "+855 (CAM)", country: "Cambodia" },
  { value: "+856", label: "+856 (LAO)", country: "Laos" },
  { value: "+880", label: "+880 (BAN)", country: "Bangladesh" },
  { value: "+886", label: "+886 (TWN)", country: "Taiwan" },
  
  // +960 - +999
  { value: "+960", label: "+960 (MDV)", country: "Maldives" },
  { value: "+961", label: "+961 (LEB)", country: "Lebanon" },
  { value: "+962", label: "+962 (JOR)", country: "Jordan" },
  { value: "+963", label: "+963 (SYR)", country: "Syria" },
  { value: "+964", label: "+964 (IRQ)", country: "Iraq" },
  { value: "+965", label: "+965 (KUW)", country: "Kuwait" },
  { value: "+966", label: "+966 (KSA)", country: "Saudi Arabia" },
  { value: "+967", label: "+967 (YEM)", country: "Yemen" },
  { value: "+968", label: "+968 (OMA)", country: "Oman" },
  { value: "+970", label: "+970 (PAL)", country: "Palestine" },
  { value: "+971", label: "+971 (UAE)", country: "United Arab Emirates" },
  { value: "+972", label: "+972 (ISR)", country: "Israel" },
  { value: "+973", label: "+973 (BHR)", country: "Bahrain" },
  { value: "+974", label: "+974 (QAT)", country: "Qatar" },
  { value: "+975", label: "+975 (BHU)", country: "Bhutan" },
  { value: "+976", label: "+976 (MGL)", country: "Mongolia" },
  { value: "+977", label: "+977 (NEP)", country: "Nepal" },
  { value: "+992", label: "+992 (TJK)", country: "Tajikistan" },
  { value: "+993", label: "+993 (TKM)", country: "Turkmenistan" },
  { value: "+994", label: "+994 (AZE)", country: "Azerbaijan" },
  { value: "+995", label: "+995 (GEO)", country: "Georgia" },
  { value: "+996", label: "+996 (KGZ)", country: "Kyrgyzstan" },
  { value: "+998", label: "+998 (UZB)", country: "Uzbekistan" }
];

// Helper function to get country by code
export const getCountryByCode = (code) => {
  return countryCodes.find(c => c.value === code);
};

// Helper function to get default country code (Pakistan +92)
export const getDefaultCountryCode = () => {
  return countryCodes.find(c => c.country === "Pakistan")?.value || "+92";
};

// Helper function to get sorted countries by name (alphabetical)
export const getSortedCountriesByName = () => {
  return [...countryCodes].sort((a, b) => a.country.localeCompare(b.country));
};

// Helper function to search countries
export const searchCountries = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return countryCodes.filter(c => 
    c.country.toLowerCase().includes(term) || 
    c.value.includes(term) || 
    c.label.toLowerCase().includes(term)
  );
};

// Helper function to get unique country codes (for cases like +1, +7)
export const getUniqueCountryCodes = () => {
  const uniqueMap = new Map();
  countryCodes.forEach(item => {
    if (!uniqueMap.has(item.value)) {
      uniqueMap.set(item.value, item);
    }
  });
  return Array.from(uniqueMap.values());
};